/**
 * "Påminnelser" in the assignment composer's external tab: the schedule this
 * delegation arms (pre-filled from Inställningar › Aviseringar), or the order's
 * existing one, which a delegation never changes.
 */
import React from 'react';
import { Form, Spinner } from 'react-bootstrap';
import ReminderFields from './ReminderFields';
import type { ComposerReminders } from '../../hooks/workOrders/useComposerReminders';
import { describeReminderTiming } from '../../types/workOrderReminders';
import './WorkOrderReminders.css';

interface ComposerRemindersBlockProps {
    reminders: ComposerReminders;
    disabled?: boolean;
    idSuffix: string;
}

const ComposerRemindersBlock: React.FC<ComposerRemindersBlockProps> = ({ reminders, disabled, idSuffix }) => {
    const { hasSchedule, existing, hasDueDate, loading, draft } = reminders;
    return (
        <div className="border rounded p-3 mb-3">
            <Form.Label className="fw-semibold">Påminnelser</Form.Label>
            {hasSchedule ? (
                <p className="small text-muted mb-0">
                    {existing
                        ? <>Ärendet har redan påminnelser: {describeReminderTiming(existing)}. De gäller alla externa mottagare</>
                        : <>Påminnelser är avstängda för ärendet</>}
                    {" "}och ändras under Detaljer.
                </p>
            ) : loading || !draft ? (
                <div><Spinner animation="border" size="sm" /></div>
            ) : (
                <>
                    <ReminderFields
                        draft={draft}
                        onChange={reminders.setDraft}
                        idPrefix={`composer-reminders-${idSuffix}`}
                        disabled={disabled}
                    />
                    {reminders.error && <div className="text-danger small mt-1">{reminders.error}</div>}
                    {!hasDueDate && draft.enabled && (
                        <Form.Group className="mt-3" controlId={`composer-reminders-due-${idSuffix}`}>
                            <Form.Label className="small mb-1">Förfallodatum</Form.Label>
                            <Form.Control
                                type="date"
                                size="sm"
                                value={reminders.dueDate}
                                disabled={disabled}
                                onChange={(e) => reminders.setDueDate(e.target.value)}
                            />
                            {!reminders.dueDate && (
                                <Form.Text className="text-warning">
                                    Ärendet saknar förfallodatum – inga påminnelser skickas förrän ett datum är satt.
                                </Form.Text>
                            )}
                        </Form.Group>
                    )}
                </>
            )}
        </div>
    );
};

export default ComposerRemindersBlock;
